<template>
  <footer class="footer">
    <div class="container custom-container">
      <div class="footer--links">
        <div class="links--home" @click="home">
          <figure class="img-responsive">
            <img
              src="../assets/logo-white.png"
              alt="Logo Branco Heliar Express"
            />
          </figure>
        </div>
        <div class="divider"></div>
        <div class="links--sociais">
          <div class="d-flex">
            <a href="https://www.instagram.com/bateriasheliar" target="_blank"
              ><span class="icon icon-instagram"></span
            ></a>
            <a href="https://www.facebook.com/bateriasheliar" target="_blank"
              ><span class="icon icon-facebook"></span
            ></a>
            <a
              href="https://www.youtube.com/user/BateriasHeliar"
              target="_blank"
              ><span class="icon icon-youtube"></span
            ></a>
            <a
              href="https://www.tiktok.com/@bateriasheliaroficial"
              target="_blank"
              ><span class="icon icon-tiktok"></span
            ></a>
            <a href="https://www.heliar.com" target="_blank"
              ><span class="icon icon-globe"></span
            ></a>
          </div>
        </div>
        <div class="divider"></div>
        <div class="links--outros">
          <p class="outros--central">
            Central de Atendimento Heliar: <a href="tel:40902020">4090-2020</a>
          </p>
          <p class="outros--central outros--central__mobile">
            Central de Atendimento: <a href="tel:40902020">4090-2020</a>
          </p>
        </div>
        <div class="divider"></div>
        <div class="links--parceiros">
          <figure class="img-responsive">
            <a
              href="https://www.stone.com.br/"
              alt="Logo de Parceiro Oficial Stone"
              target="_blank"
              ><img
                src="https://storage.googleapis.com/partnerhub_partner_badges_prod/L_62ec2efc3697920019a32337.png"
            /></a>
          </figure>
        </div>
      </div>
      <p class="footer--copyright">
        Copyright © 2025 - CLARIOS BRASIL SERVICOS LTDA | CNPJ:
        02.433.020/0001-81 - Todos os direitos reservados.
      </p>
    </div>
  </footer>
</template>

<script>
export default {
  name: "Footer",
  data() {
    return {
      ano: "",
    };
  },
  created: function() {
    var data = new Date();
    this.ano = data.getFullYear();
  },
  methods: {
    home() {
      sessionStorage.setItem("cidade", "");
      sessionStorage.setItem("carro", "");
      if (this.$route.name == "home") {
        window.location.reload();
      } else {
        this.$router.push({ name: "home" });
      }
    },
  },
};
</script>

<style lang="scss">
.footer {
  padding: 40px 0;
  color: $white;
  background-color: $cinza-escuro;
  .divider {
    width: 1px;
    background: $black;
    opacity: 0.3;
    flex-shrink: 0;
  }
  &--links {
    flex-basis: 100%;
    display: flex;
    justify-content: space-between;
    align-items: stretch;
    .links {
      &--home {
        cursor: pointer;
        padding-right: 35px;
        position: relative;
        .img-responsive {
          width: 230px;
        }
      }
      &--sociais {
        padding: 0 35px;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-wrap: wrap;
        flex-direction: column;
        .icon {
          font-size: 26px;
          color: $white;
          opacity: 0.5;
          padding-right: 30px;
        }
        a {
          &:hover {
            text-decoration: none;
          }
          &:last-child {
            .icon {
              padding-right: 0;
            }
          }
        }
      }
      &--outros {
        padding: 0 35px;
        position: relative;
        font-size: 16px;
        white-space: nowrap;
        display: flex;
        align-items: center;
        .outros {
          &--sobre {
            color: $cinza-medio;
            margin-bottom: 10px;
            display: inline-block;
          }
          &--central {
            color: $white;
            margin-bottom: 0;
            &__mobile {
              display: none;
            }
            a {
              text-decoration: none;
              color: $white;
              font-weight: 700;
            }
          }
        }
      }
      &--parceiros {
        padding-left: 35px;
        .img-responsive {
          width: 125px;
        }
      }
    }

    .img-responsive {
      margin-bottom: 0;
      img {
        max-width: 100%;
        height: auto;
      }
    }
    p {
      margin-bottom: 0;
    }
  }
  &--copyright {
    white-space: normal;
    font-size: 16px;
    text-align: center;
    margin-bottom: 0;
    margin-top: 24px;
  }
}
@media (max-width: 1600px) {
  .footer {
    &--links {
      .links {
        &--home {
          padding-right: 20px;
          .img-responsive {
            width: 200px;
          }
        }
        &--sociais {
          padding: 0 20px;
          .icon {
            font-size: 24px;
            padding-right: 20px;
          }
        }
        &--outros {
          padding: 0 20px;
          font-size: 14px;
        }
        &--parceiros {
          padding-left: 20px;
          display: flex;
          align-items: center;
          .img-responsive {
            width: 105px;
          }
        }
      }
    }
    &--copyright {
      font-size: 14px;
    }
  }
}
@media (max-width: 1200px) {
  .footer {
    &--links {
      .links {
        &--home {
          padding-right: 15px;
          .img-responsive {
            width: 175px;
          }
        }
        &--sociais {
          padding: 0 15px;
          .icon {
            font-size: 20px;
            padding-right: 14px;
          }
        }
        &--outros {
          padding: 0 15px;
          font-size: 12px;
        }
        &--parceiros {
          padding-left: 15px;
          .img-responsive {
            width: 80px;
          }
        }
      }
    }
    &--copyright {
      font-size: 12px;
    }
  }
}
@media (max-width: 991px) {
  .footer {
    padding: 38px 0;
    .divider {
      display: none;
    }
    &--links {
      flex-wrap: wrap;
      .links {
        &--home {
          flex-basis: 50%;
          padding-right: 0;
          margin-bottom: 32px;
          .img-responsive {
            width: 300px;
          }
        }
        &--sociais {
          flex-basis: 50%;
          padding: 0;
          margin-bottom: 32px;
          align-items: flex-end;
          .icon {
            font-size: 35px;
            padding-right: 40px;
          }
        }
        &--outros {
          flex-basis: 50%;
          padding: 0;
          display: flex;
          .outros {
            &--sobre {
              display: none;
            }
            &--central {
              display: none;
              &__mobile {
                display: block;
                font-size: 19px;
                a {
                  display: block;
                  font-size: 37px;
                  font-weight: 700;
                  text-align: center;
                }
              }
            }
          }
        }
        &--parceiros {
          flex-basis: 50%;
          padding-left: 0;
          justify-content: flex-end;
          .img-responsive {
            width: 175px;
          }
        }
      }
    }
  }
}
@media (max-width: 767px) {
  .footer {
    &--links {
      .links {
        &--home {
          .img-responsive {
            width: 200px;
          }
        }
        &--sociais {
          .icon {
            font-size: 30px;
            padding-right: 25px;
          }
        }
        &--outros {
          .outros {
            &--central {
              &__mobile {
                font-size: 16px;
                a {
                  font-size: 34px;
                }
              }
            }
          }
        }
        &--parceiros {
          .img-responsive {
            width: 150px;
          }
        }
      }
    }
  }
}
@media (max-width: 575px) {
  .footer {
    &--links {
      .links {
        &--home {
          flex-basis: 45%;
          .img-responsive {
            width: 125px;
          }
        }
        &--sociais {
          .icon {
            font-size: 22px;
            padding-right: 12px;
          }
        }
        &--outros {
          .outros {
            &--central {
              &__mobile {
                font-size: 12px;
                a {
                  font-size: 24px;
                }
              }
            }
          }
        }
        &--parceiros {
          .img-responsive {
            width: 125px;
          }
        }
      }
    }
  }
}
</style>
